import { FastField, Form, Formik } from 'formik';
import { useCallback } from 'react';

import { Modal } from '@shared/components/modals/Modal';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper } from '@styles/CommonStyles';
import { StyledCommentTextField } from '@styles/ContactManager/DealStyles';

interface ICommentModalProps {
  loading: boolean;
  meridanModalPosition: number;
  onClose: () => void;
  handleSubmit: (data?: { comment: string }) => void;
}

const initialValues = {
  comment: ''
};

export const MeridianCommentModal = ({ loading, meridanModalPosition, onClose, handleSubmit }: ICommentModalProps) => {

  const handleClose = useCallback(() => {
    if (!loading) {
      onClose();
    }
  }, [loading]);

  return (
    <Modal
      open
      title="Comment"
      dialogHeight="310px"
      dialogWidth="500px"
      resetPosition={meridanModalPosition}
      isSubmitting={loading}
      onClose={handleClose}
    >
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={null}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            <FastField
              multiline
              name="comment"
              label=" "
              component={StyledCommentTextField}
              variant="outlined"
              minRows={7}
              maxRows={7}
            />

            <CommonButtonWrapper>
              <CancelButton disabled={loading} onClick={handleClose} />
              <SaveButton label="Send" disabled={!props.values.comment} isLoading={loading} />
            </CommonButtonWrapper>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};